var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn-fullscreen', {'btn-fullscreen--exit': _vm.isFullscreen}],on:{"click":function($event){_vm.isFullscreen ? _vm.closeFullscreen() : _vm.openFullscreen()}}},[_c('span',[_vm._v("Toggle fullscreen")])])}
var staticRenderFns = []

export { render, staticRenderFns }